import { render, staticRenderFns } from "./TiIcon.vue?vue&type=template&id=6ef339ab&"
import script from "./TiIcon.vue?vue&type=script&lang=ts&"
export * from "./TiIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports